module.exports = __webpack_public_path__ + "img/W-S67.826ef9d9.jpg";